import { render, staticRenderFns } from "./PointExpire.vue?vue&type=template&id=dc036df6"
import script from "./PointExpire.vue?vue&type=script&lang=js"
export * from "./PointExpire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports